import yaml from 'js-yaml';
import type { GuidelineDraftContent } from '../types/accuracy';
import { emptyDraftMetadata, normalizeDraftContent } from './guidelineDraftMetadata';
import {
  buildGuidelineDraftYaml,
  parseItemsSection,
  parseMetadataSection,
} from './guidelineYamlBody';

export function draftContentToYaml(content: GuidelineDraftContent): string {
  const normalized = normalizeDraftContent(content);
  return buildGuidelineDraftYaml({
    guideline_id: normalized.guideline_id,
    base_version: normalized.base_version,
    metadata: normalized.metadata ?? emptyDraftMetadata(),
    categories: normalized.violation_categories,
  });
}

export function parseDraftContentYaml(text: string): GuidelineDraftContent {
  const parsed = yaml.load(text);
  if (!parsed || typeof parsed !== 'object') {
    throw new Error('YAML の形式が正しくありません');
  }
  const obj = parsed as Record<string, unknown>;

  const guideline_id = String(obj.guideline_id ?? '').trim();
  const base_version = Number(obj.base_version);
  if (!guideline_id || Number.isNaN(base_version)) {
    throw new Error('guideline_id / base_version が必要です');
  }

  const metadata = parseMetadataSection(obj.metadata) ?? emptyDraftMetadata();
  const violation_categories =
    parseItemsSection(obj.items).length > 0
      ? parseItemsSection(obj.items)
      : parseItemsSection(obj.violation_categories);

  if (violation_categories.length === 0 && !obj.items && !obj.violation_categories) {
    throw new Error('items または violation_categories が必要です');
  }

  return normalizeDraftContent({
    guideline_id,
    base_version,
    metadata,
    violation_categories,
  });
}
